var _excluded = ["domRef", "className", "type", "size", "color", "closeable", "fill", "block", "onClose", "style", "disabled", "children", "colorScheme", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { classnames } from '@okee-uikit/react-utils';
import { usePrefixCls, useDirection } from '@okee-uikit/react-config';
import { Close } from '../../common/icons';
export function Tag(props) {
  var _usePrefixCls;

  var domRef = props.domRef,
      className = props.className,
      _props$type = props.type,
      type = _props$type === void 0 ? 'default' : _props$type,
      _props$size = props.size,
      size = _props$size === void 0 ? 'md' : _props$size,
      color = props.color,
      closeable = props.closeable,
      _props$fill = props.fill,
      fill = _props$fill === void 0 ? false : _props$fill,
      _props$block = props.block,
      block = _props$block === void 0 ? false : _props$block,
      onClose = props.onClose,
      style = props.style,
      disabled = props.disabled,
      children = props.children,
      propsColorScheme = props.colorScheme,
      variant = props.variant,
      extra = _objectWithoutProperties(props, _excluded);

  var colorScheme = useMemo(function () {
    if (propsColorScheme) return propsColorScheme;else if (fill) {
      return type === 'error' ? 'danger' : type;
    } else {
      return type === 'error' ? 'danger-light' : type === 'color' || type === 'checkable' ? type : type + '-light';
    }
  }, [type, propsColorScheme]);
  var direction = useDirection();
  var cls = classnames(usePrefixCls('tag', (_usePrefixCls = {
    size: size
  }, _defineProperty(_usePrefixCls, colorScheme, true), _defineProperty(_usePrefixCls, "fill", (variant === null || variant === void 0 ? void 0 : variant.includes('fill')) || fill), _defineProperty(_usePrefixCls, "closable", closeable), _defineProperty(_usePrefixCls, 'closable-rtl', closeable && direction === 'rtl'), _defineProperty(_usePrefixCls, "rtl", direction === 'rtl'), _defineProperty(_usePrefixCls, "disabled", disabled), _defineProperty(_usePrefixCls, "dashed", variant === null || variant === void 0 ? void 0 : variant.includes('dashed')), _defineProperty(_usePrefixCls, "text", variant === null || variant === void 0 ? void 0 : variant.includes('text')), _usePrefixCls)), className);
  var closeCls = usePrefixCls('tag-close', {
    rtl: direction === 'rtl'
  });
  var onCloseClick = useCallback(function (e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    onClose && onClose(e);
  }, [onClose]);
  var closeNode = closeable ? React.createElement("span", {
    className: closeCls,
    onClick: onCloseClick
  }, React.createElement(Close, {
    strokeWidth: 6
  })) : null;
  var css = {};

  if (block) {
    css.display = 'block';
  }

  if (color && type === 'color') {
    if (fill) {
      css.backgroundColor = color;
    } else {
      css.borderColor = color;
      css.color = color;
    }
  }

  return React.createElement("span", _objectSpread(_objectSpread({}, extra), {}, {
    style: _objectSpread(_objectSpread({}, style), css),
    className: cls,
    ref: domRef
  }), children, closeNode);
}